<template>
  <div class="page-add">
    <div class="add-title">{{ !editId ? "新增申报" : "编辑申报" }}</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="120px"
      :rules="rules"
      :model="reportForm"
      ref="reportForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="申报名称：" prop="reportName">
            <el-select
              v-model="reportForm.reportYear"
              class="yearSelect"
              placeholder="请选择年份"
            >
              <el-option
                v-for="(item, index) in yearList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              class="reportName"
              v-model="reportForm.reportName"
              placeholder="请输入申报名称"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="申报时间：" prop="reportTime">
            <el-date-picker
              unlink-panels
              v-model="reportForm.reportTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="申报简介：" prop="desc">
            <el-input
              type="textarea"
              rows="4"
              v-model="reportForm.desc"
              placeholder="请输入申报简介"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="scale" label="申报部门：" prop="reportDeptNames">
            <el-input
              class="form-dept"
              v-model="reportForm.reportDeptNames"
              placeholder="请选择可申报部门"
              :readonly="true"
            ></el-input>
            <el-button class="button-dept" @click="selectDep">选择</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            class="scale"
            label="申报附件："
            prop="reportAttachment"
          >
            <upload
              :limit="1"
              :path="'class/attachment'"
              :accepts="accepts"
              v-model="reportForm.attachmentList"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <el-button @click="resetForm" v-show="!editId">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <dept
      :defaultCheckedKeys="defaultCheckedKeys"
      @enrollDeptSelected="enrollDeptSelected"
    ></dept> -->
    <DeptNew :enrollDeptVos="checkedEnrollDeptVos" @enrollDeptSelected="enrollDeptSelected" />
  </div>
</template>

<script>
import { Confirm } from "@/components/Confirm";
import { saveClassReport, updateClassReport, getClassReportInfo } from "@/api/classReport.js"
import vue from "../../../main";
import moment from "moment";
import Upload from "@/components/upload/index";
import rulesFactory from "@/utils/rules";
import { setItem } from "@/utils/storage.js";
import DeptNew from "../../onlineClass/add/deptNew";
import { getTopDepts } from "@/api/dept";

export default {
  name: "reportAdd",
  components: { Upload, DeptNew },
  data() {
    return {
      checkedEnrollDeptVos: [],
      topDeptList: [],
      props: {
        //树形
        value: "key",
        label: "name",
        children: "children",
      },
      editId: null,
      accepts: ["word", "pdf", "jpg", "png"],
      reportForm: {
        reportName: "",
        reportYear: '',
        reportTime: [],
        desc: "",
        attachmentList: [],
        reportDeptIds: [],
      },
      yearList: [],
      rules: {
        reportName: [
          rulesFactory.required("请输入申报名称"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        reportTime: [rulesFactory.required("请选择申报时间")],
        desc: [
          rulesFactory.required("请输入申报简介"),
          rulesFactory.size("最多输入500个字", 0, 500),
        ],
        reportDeptNames: [rulesFactory.required("请选择报名部门")],
      },
    };
  },
  created() {
    this.getYearList();
    this.editId = this.$route.query.id;
    if (!!this.editId) {
      this.getInfo();
    }
  },
  methods: {
    goBack() {
      this.$router.push('/classReport');
    },
    getInfo() {
      getClassReportInfo({uuid:this.editId}).then(res => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        obj.reportTime = [moment(obj.reportStartTime), moment(obj.reportEndTime)];
        if (obj.attachment) {
          obj.attachmentList = JSON.parse(obj.attachment);
        } else {
          obj.attachmentList = [];
        }
        obj.reportYear = obj.reportYear.toString();
        delete obj['reportStartTime']
        delete obj['reportEndTime']
        delete obj['reportAttachment']
        this.reportForm = obj;
        this.checkedEnrollDeptVos = this.reportForm.enrollDeptVos;
      })
    },

    /**
     * 选择完部门
     */
    enrollDeptSelected(dept) {
      this.$set(this.reportForm, "reportDeptIds", dept.ids);
      this.$set(this.reportForm, "enrollDeptVos", dept.enrollDeptVos);
      this.checkedEnrollDeptVos = this.reportForm.enrollDeptVos;
      this.reportForm.reportDeptNames = dept.names.join(",");
      this.getTopDepts(dept.enrollDeptVos);
    },
    // 查询部门树顶节点-zhaogang
    getTopDepts(nodeArr) {
      getTopDepts(nodeArr).then((res) => {
        if (!res || res.code != 0) return;
        this.topDeptList = res.data || [];
      });
    },
    /**
     * 点击选择部门
     */
    selectDep() {
      vue.$emit("selectDep");
    },

    // 重置表单数据
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        this.$refs["reportForm"].resetFields();
        this.reportForm = {
         reportName: "",
         reportYear: '',
         reportTime: [],
         desc: "",
         attachmentList: [],
       }
       this.getYearList();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    /**
     * 点击提交
     */
    submit() {
      this.$refs["reportForm"]
        .validate()
        .then(() => {
          let params = Object.assign({}, this.reportForm);
          if (this.topDeptList && this.topDeptList.length > 0) {
            params["enrollDeptVos"] = JSON.parse(JSON.stringify(this.topDeptList));
            params["reportDeptIds"] = this.topDeptList.map((ele) => ele.deptId);
          }
          params["reportStartTime"] = moment(
            this.reportForm.reportTime[0]
          ).format("YYYY-MM-DD");
          params["reportEndTime"] = moment(this.reportForm.reportTime[1]).format(
            "YYYY-MM-DD"
          );
          delete params["reportTime"];
          if (this.reportForm.attachmentList.length > 0) {
            params["attachment"] = JSON.stringify(
              this.reportForm.attachmentList
            );
          } else {
            params["attachment"] = null;
          }
          delete params["attachmentList"];
          this.requestSave(params);
        })
        .catch(() => {});
    },

    requestSave(params) {
      if (!this.editId) {
        saveClassReport(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "办班申请新增成功！",
            type: "success",
          });
          this.goBack();
        });
      } else {
        updateClassReport(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "办班申请修改成功！",
            type: "success",
          });
          this.goBack();
        });
      }
    },

    getYearList() {
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      this.$set(this.reportForm, "reportYear", year + 1 + '');
      this.yearList = [`${year - 1}`, year.toString(), `${year + 1}`];
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}
/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}
.form-select {
  width: 100%;
}
/deep/ .el-form-item__content {
  .form-dept {
    width: calc(100% - 90px);
    font-size: inherit;
  }
  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }
  .el-date-editor--daterange.el-input__inner {
    width: 100% !important;
  }

  .reportName {
    width: calc(100% - 160px) !important;
  }
  .el-select.yearSelect {
    .el-input--small {
      width: 150px !important;
      margin-right: 10px;
    }
  }
}
.form-text-center {
  text-align: center !important;
}
</style>
